import React, { useEffect, useState } from 'react'
import { Modal } from 'react-responsive-modal'
import { BlockType } from '../../containers/LessonPage/types'
import moment from 'moment'
import usePrevious from '../../hooks/usePrevious'

// Components
import Loading from '../Loading'

// Styles
import './styles.scss'

// Modal styles
const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 400,
    borderRadius: 20,
    padding: 20,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

export default ({
  modal,
  blocks,
  notionId,
  isFetching,
  onClose,
  onReloadBlocks,
  onUpdate,
  onFetch,
}: {
  modal: boolean
  blocks: BlockType[]
  notionId: string
  isFetching: boolean
  onClose: (type: boolean) => void
  onReloadBlocks: () => void
  onUpdate: (block_id: string, notion_page_id: string) => void
  onFetch: (block_id: string, block_notion_id: string) => void
}): JSX.Element => {
  const [notionIdValue, setNotionIdValue] = useState<string>('')

  const prevProcessIsFetchingNotion = usePrevious(isFetching)

  useEffect(() => {
    if (!isFetching && prevProcessIsFetchingNotion) {
      onReloadBlocks()
    }
  }, [isFetching])

  const currentBlock = notionId
    ? blocks.find(block => block.block_id === notionId)
    : false

  useEffect(() => {
    if (currentBlock) {
      const currentNotionId = currentBlock.notion.notion_page_id
      setNotionIdValue(currentNotionId)
    }
  }, [currentBlock])

  const handleSyncNotion = () => {
    if (currentBlock) {
      onFetch(currentBlock.block_id, currentBlock.notion.block_notion_id)
    }
  }

  const handleUpdateBlock = () => {
    if (currentBlock) {
      onUpdate(currentBlock.block_id, notionIdValue)
    }
  }

  return (
    <Modal
      open={modal}
      styles={customModalStyles}
      onClose={() => onClose(false)}
      center={true}
    >
      {currentBlock ? (
        <div className={'admin-notion-block'}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <h3 style={{ margin: 0 }}>Изменить блок Notion</h3>
            {isFetching ? (
              <Loading
                style={{ margin: '0 0 0 5px' }}
                width={20}
                height={20}
                color={'#1978B2'}
              />
            ) : null}
          </div>
          <label htmlFor={'notion-id'}>Notion ID</label>
          <input
            style={{ margin: '0 0 10px', outline: 0 }}
            id={'notion-id'}
            type={'text'}
            placeholder={''}
            autoComplete={'off'}
            value={notionIdValue}
            onChange={event => setNotionIdValue(event.target.value)}
          />
          <button
            onClick={handleSyncNotion}
            style={{ marginBottom: 10 }}
            hidden={
              !notionIdValue ||
              currentBlock.notion.notion_page_id !== notionIdValue
            }
          >
            Синхронизировать
          </button>
          <p style={{ marginTop: 0, marginBottom: 5 }}>
            Дата последней синхронизации:
            <br />{' '}
            <span style={{ margin: 0, fontWeight: 700 }}>
              {moment(currentBlock.notion.updated_at).format('LLLL')}
            </span>
          </p>
          <p style={{ marginTop: 0 }}>
            Состояние:
            <br />{' '}
            {currentBlock.notion.fetched ? (
              <span style={{ color: 'green', fontWeight: 700 }}>
                Синхронизированно
              </span>
            ) : (
              <span style={{ color: 'red', fontWeight: 700 }}>
                Не синхронизированно
              </span>
            )}
          </p>
          <button
            onClick={handleUpdateBlock}
            disabled={
              !notionIdValue ||
              currentBlock.notion.notion_page_id === notionIdValue
            }
          >
            Сохранить
          </button>
        </div>
      ) : null}
    </Modal>
  )
}
